import { useEffect, useState } from "react";

interface Particle {
  id: number;
  style: React.CSSProperties;
}

const config = {
  BURST_DURATION: 4000,
  ANIMATION_DURATION: 2500,
  MIN_REVEAL_RADIUS: 10,
  MAX_REVEAL_RADIUS: 20,
};

export const useGemAnimation = (gems: number) => {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    const newParticles: Particle[] = [];

    for (let i = 0; i < gems; i++) {
      const baseAngle = (i / gems) * 2 * Math.PI;
      const angleJitter = (Math.random() - 0.5) * 0.5;
      const finalAngle = baseAngle + angleJitter;

      const randomRadius =
        Math.random() * (config.MAX_REVEAL_RADIUS - config.MIN_REVEAL_RADIUS) +
        config.MIN_REVEAL_RADIUS;

      const revealX = Math.cos(finalAngle) * randomRadius;
      const revealY = Math.sin(finalAngle) * randomRadius;

      const size = Math.random() * 2 + 18;

      newParticles.push({
        id: i,
        style: {
          width: `${size}px`,
          height: `${size}px`,
          "--reveal-x": `${revealX}px`,
          "--reveal-y": `${revealY}px`,
          animationDuration: `${config.ANIMATION_DURATION}ms`,
        },
      });
    }

    setParticles(newParticles);

    const cleanupTimer = setTimeout(() => {
      setParticles([]);
    }, config.BURST_DURATION);

    return () => clearTimeout(cleanupTimer);
  }, [gems]);

  return particles;
};
